/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the UserProfile interface.
 */
export function instanceOfUserProfile(value) {
    let isInstance = true;
    return isInstance;
}
export function UserProfileFromJSON(json) {
    return UserProfileFromJSONTyped(json, false);
}
export function UserProfileFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (json['deletedAt'] === null ? null : new Date(json['deletedAt'])),
        'rowVersion': !exists(json, 'rowVersion') ? undefined : json['rowVersion'],
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
        'isBanned': !exists(json, 'isBanned') ? undefined : json['isBanned'],
        'isEmailVerified': !exists(json, 'isEmailVerified') ? undefined : json['isEmailVerified'],
        'isPhoneNumberVerified': !exists(json, 'isPhoneNumberVerified') ? undefined : json['isPhoneNumberVerified'],
        'role': !exists(json, 'role') ? undefined : json['role'],
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'givenName': !exists(json, 'givenName') ? undefined : json['givenName'],
        'familyName': !exists(json, 'familyName') ? undefined : json['familyName'],
        'emailAddress': !exists(json, 'emailAddress') ? undefined : json['emailAddress'],
        'nickname': !exists(json, 'nickname') ? undefined : json['nickname'],
        'picture': !exists(json, 'picture') ? undefined : json['picture'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
    };
}
export function UserProfileToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'isDeleted': value.isDeleted,
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt === null ? null : value.deletedAt.toISOString()),
        'rowVersion': value.rowVersion,
        'subject': value.subject,
        'isActive': value.isActive,
        'isBanned': value.isBanned,
        'isEmailVerified': value.isEmailVerified,
        'isPhoneNumberVerified': value.isPhoneNumberVerified,
        'role': value.role,
        'countryCode': value.countryCode,
        'name': value.name,
        'givenName': value.givenName,
        'familyName': value.familyName,
        'emailAddress': value.emailAddress,
        'nickname': value.nickname,
        'picture': value.picture,
        'phoneNumber': value.phoneNumber,
    };
}
